import { CmdbReportPageService } from './service/cmdb-report-page.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Consumable } from 'src/app/util/interfaces/stockConsumables';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from './../../../services/profile/profile.service';
import { ciInterface } from 'src/app/util/interfaces/ci';
import { environment } from 'src/environments/environment';
import { Console } from 'node:console';
import { LegacyPageEvent as PageEvent, MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { JsonPipe } from '@angular/common';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { FormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { Subject } from 'rxjs';
import { element } from 'protractor';
import * as CryptoJS from 'crypto-js';

@Component({
	selector: 'app-cmdb-report-page',
	templateUrl: './cmdb-report-page.component.html',
	styleUrls: ['./cmdb-report-page.component.scss'],
})
export class CmdbReportPageComponent implements OnInit {
	simpleKey = 'simpleKey';

	faAngleRight = faAngleRight;

	labels: any = {
		lbl_edocs_carregando: 'Loading',
		lbl_geral_reports: 'Reports',
		lbl_create_report: 'Create new report',
		lbl_geral_voltar: 'Back',
		lbl_geral_campos_disponiveis: 'Available fields',
		lbl_incluir_campos_final_relatorio: 'Include fields in the filter, inclusions go to the end of the form',
		lbl_geral_criado_com_sucesso: 'Succesful created',
		lbl_campo_adicionado_no_final: 'Field added at the end of the form',
		lbl_geral_exportar_excel: 'Export to excel',
		lbl_geral_quantidade: 'Amount',
		lbl_geral_saida: 'Exit',
		lbl_geral_ativo: 'Active',
		lbl_geral_usuario: 'User',
		lbl_geral_data: 'Date',
		lbl_geral_identificacao: 'Identification',
		lbl_geral_responsavel: 'Responsible',
		lbl_geral_local: 'Location',
		lbl_geral_entrada: 'Entry',
		lbl_cmdb: 'CMDB',
		lbl_asset_consumiveis: 'Consumables',
		lbl_geral_data_retorno: 'Return date',
		lbl_geral_data_retorno_esperada: 'Expected return date',
		lbl_geral_movement_date: 'Movement date',
		lbl_filtros_aplicaveis: 'Applicable filters',
		lbl_geral_selecione: 'Select an option',
		lbl_geral_novos_itens: 'New items',
		lbl_selecione_filtro_info: "If you don't select a filter, the report will come with all available information.",
		lbl_projetos_nao_existe_item_parametros_pesquisa_requeridos: 'There are no items registered for the required search criteria.',
		lbl_stock_emprestimo: 'Lending',
		lbl_geral_quan_pen: 'Pending Quantity',
		lbl_geral_work_without_contract: 'Microcomputer without Contract',
		lbl_existem_qtd_ativos_com_campo_registrado: '',
		lbl_existem_qtd_ativos_sem_campo_registrado: '',
		lbl_geral_status: '',
		lbl_cmdb_qtd_licenca: '',
		lbl_geral_sim: '',
		lbl_geral_nao: '',
		lbl_geral_sem_rastreio: '',
		lbl_geral_desuso: '',
		lbl_status_em_uso: '',
		lbl_geral_descontinuado: '',
		lbl_geral_em_renovacao: 'Em renovação',
		lbl_geral_qtd_disponivel: '',
		lbl_geral_qtd_instaladas: '',
		lbl_geral_qtd_contratada: '',
		lbl_cmdb_licenca: '',
		lbl_geral_status_licenca: '',
		lbl_asset_sw_instalados: '',
		lbl_geral_exibir: '',
		lbl_rep_ne_dados_disponiveis: '',
		lbl_último: '',
		lbl_security_nenhum_registro: '',
		lbl_slam_de: '',
		lbl_geral_mostrando: '',
		lbl_geral_primeiro: '',
		lbl_geral_processando: '',
		lbl_geral_registros: '',
		lbl_geral_proximo: '',
		lbl_geral_anterior: '',
		lbl_geral_todos: '',
		lbl_geral_nome_do_host: 'Host name',
		lbl_geral_tag_id: 'tag id',
		lbl_geral_localidade: 'location',
		lbl_geral_depto: 'department',
		lbl_asset_proprietario: 'Owner',
		lbl_micro_notexist_ad: 'Microcomputers in CMDB not found in AD',
		lbl_microad_notexist_cmdb: 'Microcomputers in AD not found in CMDB',
		lbl_geral_site: 'Site',
		lbl_selecione_para_continuar: '',
		lbl_rep_gerar_relatorio: '',
		lbl_status_estoque: '',
		lbl_cmdb_report_select_ciType_software: '',
		lbl_status_em_manutencao: '',
		lbl_geral_inativo: '',
		lbl_an_errour_occour: '',
		lbl_cmdb_last_modification_date: '',
		lbl_geral_relatorio: 'Report',
		lbl_relatorios_especiais: '',
	};

	constructor(
		private CmdbReportPageService: CmdbReportPageService,
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private ProfileService: ProfileService
	) {}

	pageView = 'report-list';
	spreadsheetView = '';

	reportOptionArray = [
		{
			pageView: 'register',
			spreadsheetView: 'reportCost',
			label: 'lbl_projetos_custo',
			icon: '',
			function: () => {
				this.getFormOptions(this.spreadsheetView);
			},
		},
		{
			pageView: 'register',
			spreadsheetView: 'withoutRelated',
			label: 'lbl_geral_work_without_contract',
			icon: '',
			function: () => {
				this.getFormOptions(this.spreadsheetView);
			},
		},
		{
			pageView: 'register',
			spreadsheetView: 'logIntegrationInventory',
			label: 'lbl_geral_log_integration_inventory',
			icon: '',
			function: () => {
				this.getFormOptions(this.spreadsheetView);
			},
		},
		{
			pageView: 'register',
			spreadsheetView: 'software',
			label: 'lbl_asset_sw_instalados',
			icon: '',
			function: () => {
				this.getFormOptions(this.spreadsheetView);
			},
		},
		{
			pageView: 'register',
			spreadsheetView: 'software_x_license',
			label: 'lbl_cmdb_licenca',
			icon: '',
			function: () => {
				this.getFormOptions(this.spreadsheetView);
			},
		},
		{
			pageView: 'register',
			spreadsheetView: 'calculateMonthlyDepreciation',
			label: 'lbl_geral_accumulated_depreciation',
			icon: '',
			function: () => {
				this.getFormOptions(this.spreadsheetView);
			},
		},
		{
			pageView: 'extractQr',
			spreadsheetView: '',
			label: 'lbl_identificadores_extras',
			icon: '',
			function: () => {
				this.getAllQrCodes();
			},
		},
		{
			pageView: 'register',
			spreadsheetView: 'reportAD',
			label: 'lbl_microad_notexist_cmdb',
			icon: '',
			function: () => {
				this.getFormOptions(this.spreadsheetView);
			},
		},
		{
			pageView: 'register',
			spreadsheetView: 'reportMicroNotAD',
			label: 'lbl_micro_notexist_ad',
			icon: '',
			function: () => {
				this.getFormOptions(this.spreadsheetView);
			},
		},
	];

	@ViewChild(MatPaginatorModule)
	paginator: MatPaginatorModule;

	isLoadingReportList = false;
	isLoadingLabels = true;
	isLoadingRegisterFormOptions = false;
	isLoadingQrCodes = false;
	isLoadingBarCodes = false;

	savedReports: { name: string; params: genericFormInterface[] }[] = [];

	consumablesInterface: Consumable[] = [];

	registerFormOptions: genericFormInterface[] = [];
	selectedFormOptions: genericFormInterface[] = [];

	cisWithQrCode: ciInterface['ciArray'][number][] = [];
	cisWithoutQrCode: ciInterface['ciArray'][number][] = [];
	cisWithBarCode: ciInterface['ciArray'][number][] = [];
	cisWithoutBarCode: ciInterface['ciArray'][number][] = [];

	isRegisterAdvancedOpen = true;

	dtOptions: DataTables.Settings = {};
	dtTrigger: Subject<any> = new Subject<any>();

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		if (localStorage.getItem('cmdbSavedExport')) {
			const cmdbSavedExport = CryptoJS.AES.decrypt(localStorage.getItem('cmdbSavedExport'), this.simpleKey).toString(
				CryptoJS.enc.Utf8
			);
			this.savedReports = JSON.parse(cmdbSavedExport);
		}
	}

	getFormOptions(formOption: string): void {
		this.isLoadingRegisterFormOptions = true;
		this.CmdbReportPageService.getFormOptions(formOption).subscribe((registerFormOptions) => {
			this.registerFormOptions = registerFormOptions;
			this.handleMockHideForms();

			this.registerFormOptions.sort((a, b) => {
				if (this.labels[a.label] > this.labels[b.label]) return 1;
				if (this.labels[a.label] < this.labels[b.label]) return -1;
				return 0;
			});
			this.isLoadingRegisterFormOptions = false;

			// registerFormOptions.forEach(fixedOption => {

			//   if (fixedOption.selected == true && this.spreadsheetView == 'software' || fixedOption.selected == true && this.spreadsheetView == 'software_x_license') {
			//     this.getFixedForm(fixedOption);
			//   }
			// });
		});
	}

	// getFixedForm(formItem: genericFormInterface): void {
	//   this.selectedFormOptions.push(formItem);
	//   this.selectedFormOptions.sort((a, b) => {
	//     if (this.labels[a.label] > this.labels[b.label]) return 1;
	//     if (this.labels[a.label] < this.labels[b.label]) return -1;
	//     return 0
	//   })
	// }

	selectForm(formItem: genericFormInterface, notify?): void {
		this.selectedFormOptions.push(formItem);
		this.selectedFormOptions.sort((a, b) => {
			if (this.labels[a.label] > this.labels[b.label]) return 1;
			if (this.labels[a.label] < this.labels[b.label]) return -1;
			formItem.selected = true;
			return 0;
		});

		if (notify === undefined || notify === true) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_campo_adicionado_no_final);
		}
	}

	unselectForm(formItem: any): void {
		for (const [index, selectedFormItem] of this.selectedFormOptions.entries()) {
			if (selectedFormItem === formItem) {
				formItem.values = [''];
				formItem.selected = false;
				this.selectedFormOptions.splice(index, 1);
			}
		}
	}

	unselectAllForm(): void {
		this.isRegisterAdvancedOpen = true;
		this.selectedFormOptions = [];
		for (const formOption of this.registerFormOptions) {
			formOption.selected = false;
			formOption.values = [''];
		}
	}

	createReport(): void {
		const validParameters = true;

		if (validParameters) {
			this.isLoadingReportList = true;
			this.CmdbReportPageService.createReport(this.spreadsheetView, this.selectedFormOptions).subscribe(
				(retorno) => {
					if (retorno.length === 0) {
						this.isLoadingReportList = false;
						return this.NotificationService.setNotificationMessage(
							this.labels.lbl_projetos_nao_existe_item_parametros_pesquisa_requeridos
						);
					} else {
						this.isLoadingReportList = true;
						this.unselectAllForm();
						this.pageView = 'spreadsheet';
						this.consumablesInterface = retorno;
						this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
						this.isLoadingReportList = false;
					}
				},
				(error) => {
					this.isLoadingReportList = false;
					return this.NotificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
				}
			);
		}

		this.dtTrigger.next(null);

		this.dtOptions = {
			pagingType: 'full_numbers',
			paging: true,
			pageLength: 10,
			lengthMenu: [
				[10, 50, 100, -1],
				[10, 50, 100, this.labels.lbl_geral_todos],
			],
			language: {
				emptyTable: this.labels.lbl_rep_ne_dados_disponiveis,
				info:
					this.labels.lbl_geral_mostrando +
					' _START_ ' +
					this.labels.lbl_slam_de +
					' _END_ ' +
					this.labels.lbl_slam_de +
					'_TOTAL_ ' +
					this.labels.lbl_geral_registros,
				infoEmpty:
					this.labels.lbl_geral_mostrando +
					' 0 ' +
					this.labels.lbl_slam_de +
					' 0 ' +
					this.labels.lbl_slam_de +
					'0 ' +
					this.labels.lbl_geral_registros,
				lengthMenu: this.labels.lbl_geral_exibir + ' _MENU_ ' + this.labels.lbl_geral_registros,
				loadingRecords: this.labels.lbl_edocs_carregando,
				processing: this.labels.lbl_geral_processando,
				search: this.labels.lbl_geral_pesquisar,
				zeroRecords: this.labels.lbl_security_nenhum_registro,
				paginate: {
					first: this.labels.lbl_geral_primeiro,
					last: this.labels.lbl_último,
					next: this.labels.lbl_geral_proximo,
					previous: this.labels.lbl_geral_anterior,
				},
			},
		};
	}

	exportExcel(): void {
		this.CmdbReportPageService.exportExcel();
	}

	handleMockHideForms(): any {
		const mockCostCenterCustomer = ['1566'];
		if (mockCostCenterCustomer.includes(this.ProfileService.userData().idCustomer.toString())) {
			for (let index = 0; index < this.consumablesInterface.length; index++) {
				if (this.consumablesInterface[index].ccCustomer === 'ccCustomer') {
					this.registerFormOptions[index].hidden = true;
					break;
				}
				return false;
			}
		} else {
			for (let index = 0; index < this.consumablesInterface.length; index++) {
				if (this.consumablesInterface[index].costCenter === 'costCenter') {
					this.registerFormOptions[index].hidden = true;
					break;
				}
				return true;
			}
		}
	}

	getAllQrCodes(): void {
		this.isLoadingQrCodes = true;
		this.isLoadingBarCodes = true;
		this.CmdbReportPageService.getAllQrCodes().subscribe((qrCodes) => {
			for (const qrCode of qrCodes.hasQR) {
				const newCi: ciInterface['ciArray'][number] = {
					cmdb_id: qrCode.id,
					id: qrCode.id,
					identification: qrCode.identification,
					type: 'N/A',
					qrCode: qrCode.qrCode,
				};
				this.cisWithQrCode.push(newCi);
			}

			for (const qrCode of qrCodes.noQR) {
				const newCi: ciInterface['ciArray'][number] = {
					cmdb_id: qrCode.id,
					id: qrCode.id,
					identification: qrCode.identification,
					type: 'N/A',
					qrCode: qrCode.qrCode,
				};
				this.cisWithoutQrCode.push(newCi);
			}
			this.isLoadingQrCodes = false;
		});

		this.CmdbReportPageService.getAllBarCodes().subscribe((barCodes) => {
			for (const barCode of barCodes.hasBar) {
				const newCi: ciInterface['ciArray'][number] = {
					cmdb_id: barCode.id,
					id: barCode.id,
					identification: barCode.identification,
					type: 'N/A',
					barCode: barCode.barCode,
				};
				this.cisWithBarCode.push(newCi);
			}

			for (const barCode of barCodes.noBar) {
				const newCi: ciInterface['ciArray'][number] = {
					cmdb_id: barCode.id,
					id: barCode.id,
					identification: barCode.identification,
					type: 'N/A',
					barCode: barCode.barCode,
				};
				this.cisWithoutBarCode.push(newCi);
			}
			this.isLoadingBarCodes = false;
		});
	}

	downloadAllQrCodes(type: 'barcode' | 'qrcode'): void {
		window.open('print/cmdb/' + type, '_blank');
	}
}
